import { TaskService, type Task } from '../../services/taskService'
import { LifeAreasPicker } from '../ui/LifeAreasPicker'

/**
 * A task's life areas, edited in place from the summary line. The picker
 * itself is generic (`ui/LifeAreasPicker`); this wrapper knows how a task
 * saves and reloads.
 */
interface Props {
  task: Task
  onChanged: (task: Task) => void
  editable?: boolean
  className?: string
}

export function LifeAreaPicker({ task, onChanged, editable = true, className = '' }: Props) {
  const current: string[] = (task.life_areas && task.life_areas.length > 0)
    ? task.life_areas
    : task.life_area ? [task.life_area] : []
  const save = async (values: string[]) => {
    const svc = new TaskService()
    await svc.updateTask(task.id, { life_areas: values })
    onChanged(await svc.getTask(task.id))
  }
  return <LifeAreasPicker value={current} onSave={save} editable={editable} className={className} testId="task-life-area" />
}

export default LifeAreaPicker
